<div class="indicator-box">
  <div class="indicator" [style.left]="percentComplete()"></div>
</div>
<div class="bar">
  <div class="bar-fill h100" [style.width]="percentComplete()"></div>
</div>
